import { useCallback, useLayoutEffect, useRef } from 'react'

/**
 * A callback whose identity never changes but always calls the latest `callback`, so memoised
 * rows keep skipping when a parent passes a fresh inline handler on every playback tick.
 * Call the result from event handlers only, never during render.
 */
export function useStableCallback<Args extends unknown[], Result>(
  callback: (...args: Args) => Result
): (...args: Args) => Result {
  const latest = useRef(callback)
  useLayoutEffect(() => {
    latest.current = callback
  })
  return useCallback((...args: Args) => latest.current(...args), [])
}
